import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import USE_MERCURE from '~/const/mercure';
import logout from '~/helpers/logout-helper';
import * as types from './types';
import { createCart, fetchCart as _fetchCart, addCart, updateCart, addCartCustomizable as _addCartCustomizable } from '~/services/cart';
import { fetchCustomerCart, addCustomerCart, addCustomerCartCustomizable, updateCustomerCart } from '~/services/customer';
import isValidToken from '~/helpers/connection-helper';

var formatCustomerCartQuantity = function formatCustomerCartQuantity(data) {
  var qty = data.split('|').find(function (a) {
    return a.includes('item_qty');
  });
  qty = qty ? qty.replace('item_qty:', '') : 0;
  return parseInt(qty, 10) || 0;
};

var getGraphQLErrorsCode = function getGraphQLErrorsCode(err) {
  if (err && err.length) {
    return err[0].extensions.code || '';
  }

  return '';
};

var initCart =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context) {
    var _ref2, createNewCart;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sessionStorage.removeItem('MDM_CART_ADDRESSES');
            sessionStorage.removeItem('MDM_CART_PHONE');
            sessionStorage.removeItem('MDM_RESTORE_CART');
            sessionStorage.removeItem('MDM_CC_ELIGIBLE');
            _context.next = 6;
            return createCart(context, localStorage.getItem('MDM_ACCESS_TOKEN'));

          case 6:
            _ref2 = _context.sent;
            createNewCart = _ref2.createNewCart;

            if (createNewCart) {
              _context.next = 10;
              break;
            }

            throw new Error('MDM_CART_CANNOT_CREATE_TOKEN');

          case 10:
            localStorage.setItem('MDM_CART_TOKEN', createNewCart);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initCart(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default {
  createCart: function () {
    var _createCart = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return initCart(this);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function createCart() {
      return _createCart.apply(this, arguments);
    }

    return createCart;
  }(),
  fetchCart: function () {
    var _fetchCart2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref3) {
      var commit, cart, quantity, _ref4, minicart, errors, code, data;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              cart = null;
              quantity = null;
              _context3.prev = 3;

              if (!USE_MERCURE(this.getters['i18n/locale'].iso)) {
                _context3.next = 21;
                break;
              }

              if (localStorage.getItem('MDM_CART_TOKEN')) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return");

            case 7:
              _context3.next = 9;
              return _fetchCart(this, localStorage.getItem('MDM_CART_TOKEN'), localStorage.getItem('MDM_ACCESS_TOKEN'));

            case 9:
              _ref4 = _context3.sent;
              minicart = _ref4.data.minicart;
              errors = _ref4.errors;

              if (!errors) {
                _context3.next = 16;
                break;
              }

              code = getGraphQLErrorsCode(errors);

              if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
                localStorage.removeItem('MDM_CART_TOKEN');
              }

              throw new Error(errors);

            case 16:
              cart = minicart.items;
              quantity = minicart.quantity;
              commit(types.SET_CART_STATE, 'SUCCESS');
              _context3.next = 27;
              break;

            case 21:
              localStorage.removeItem('MDM_CART_TOKEN');
              _context3.next = 24;
              return fetchCustomerCart(this);

            case 24:
              data = _context3.sent;
              quantity = data.cart;

              if (data && data.user) {
                localStorage.setItem('MDM_MAIL', data.user.user_email);
              }

            case 27:
              _context3.next = 33;
              break;

            case 29:
              _context3.prev = 29;
              _context3.t0 = _context3["catch"](3);
              this.$logger.error(_context3.t0);
              commit(types.SET_CART_STATE, 'ERROR');

            case 33:
              _context3.prev = 33;
              commit(types.SET_CART, cart);
              commit(types.SET_CART_QTY, quantity);
              return _context3.finish(33);

            case 37:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[3, 29, 33, 37]]);
    }));

    function fetchCart(_x2) {
      return _fetchCart2.apply(this, arguments);
    }

    return fetchCart;
  }(),
  add: function () {
    var _add = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(_ref5, payload) {
      var commit, state, cart, quantity, item, maxQuantityReached, _ref6, addProductsToCart, errors, totalQuantity, data, currentTotal;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref5.commit, state = _ref5.state;
              cart = null;
              quantity = null;
              _context4.prev = 3;
              item = state.items ? state.items.find(function (p) {
                return p.productReference === payload.reference;
              }) : {};
              maxQuantityReached = item && item.quantity >= 30;

              if (!USE_MERCURE(this.getters['i18n/locale'].iso)) {
                _context4.next = 28;
                break;
              }

              if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
                logout();
              }

              if (localStorage.getItem('MDM_CART_TOKEN')) {
                _context4.next = 11;
                break;
              }

              _context4.next = 11;
              return initCart(this);

            case 11:
              if (maxQuantityReached) {
                _context4.next = 23;
                break;
              }

              _context4.next = 14;
              return addCart(this, _objectSpread({
                cart: localStorage.getItem('MDM_CART_TOKEN'),
                token: localStorage.getItem('MDM_ACCESS_TOKEN')
              }, payload));

            case 14:
              _ref6 = _context4.sent;
              addProductsToCart = _ref6.data.addProductsToCart;
              errors = _ref6.errors;

              if (!errors) {
                _context4.next = 19;
                break;
              }

              throw new Error({
                message: errors[0].message,
                errorType: 'gql'
              });

            case 19:
              cart = addProductsToCart.items;
              quantity = addProductsToCart.quantity;
              _context4.next = 26;
              break;

            case 23:
              totalQuantity = state.items.reduce(function (acc, pdt) {
                return acc + pdt.quantity;
              }, 0);
              cart = state.items;
              quantity = totalQuantity;

            case 26:
              _context4.next = 34;
              break;

            case 28:
              _context4.next = 30;
              return addCustomerCart(this, payload);

            case 30:
              data = _context4.sent;
              currentTotal = state.total;
              cart = [{
                reference: payload.reference,
                productReference: payload.reference,
                quantity: formatCustomerCartQuantity(data)
              }];
              quantity = currentTotal + 1;

            case 34:
              _context4.next = 41;
              break;

            case 36:
              _context4.prev = 36;
              _context4.t0 = _context4["catch"](3);

              if (!_context4.t0.message || _context4.t0.message.indexOf('GraphQL error') === -1) {
                commit(types.SET_CART_SUCCESS_SERVER, false);
              }

              commit(types.SET_CART_SUCCESS, false);
              this.$logger.error(_context4.t0);

            case 41:
              _context4.prev = 41;
              commit(types.SET_CART, cart);
              commit(types.SET_CART_QTY, quantity);
              commit(types.SET_CART_SUCCESS, true);
              return _context4.finish(41);

            case 46:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[3, 36, 41, 46]]);
    }));

    function add(_x3, _x4) {
      return _add.apply(this, arguments);
    }

    return add;
  }(),
  update: function () {
    var _update = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(_ref7, payload) {
      var commit, cart, quantity, reference, items, _ref8, updateCartItems, data, response;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref7.commit;
              cart = null;
              quantity = null;
              reference = null;
              items = this.state.cart.items.filter(function (e) {
                return e.productReference === payload.reference;
              });

              if (items.length > 1) {
                reference = items.find(function (e) {
                  return e.offer === payload.offer;
                }).reference;
              } else {
                reference = items[0].reference;
              }

              _context5.prev = 6;

              if (!USE_MERCURE(this.getters['i18n/locale'].iso)) {
                _context5.next = 16;
                break;
              }

              _context5.next = 10;
              return updateCart(this, {
                cart: localStorage.getItem('MDM_CART_TOKEN'),
                token: localStorage.getItem('MDM_ACCESS_TOKEN'),
                quantity: payload.quantity,
                reference: reference
              });

            case 10:
              _ref8 = _context5.sent;
              updateCartItems = _ref8.updateCartItems;
              cart = updateCartItems.items;
              quantity = updateCartItems.quantity;
              _context5.next = 24;
              break;

            case 16:
              _context5.next = 18;
              return updateCustomerCart(this, payload);

            case 18:
              data = _context5.sent;
              cart = [{
                reference: payload.reference,
                productReference: payload.reference,
                quantity: data.cartItem
              }];
              _context5.next = 22;
              return fetchCustomerCart(this);

            case 22:
              response = _context5.sent;
              quantity = response.cart;

            case 24:
              _context5.next = 30;
              break;

            case 26:
              _context5.prev = 26;
              _context5.t0 = _context5["catch"](6);
              commit(types.SET_CART_SUCCESS, false);
              this.$logger.error(_context5.t0);

            case 30:
              _context5.prev = 30;
              commit(types.SET_CART, cart);
              commit(types.SET_CART_QTY, quantity);
              commit(types.SET_CART_SUCCESS, true);
              return _context5.finish(30);

            case 35:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[6, 26, 30, 35]]);
    }));

    function update(_x5, _x6) {
      return _update.apply(this, arguments);
    }

    return update;
  }(),
  addCartCustomizable: function () {
    var _addCartCustomizable2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(_ref9, payload) {
      var state, commit, currentTotal, _ref10, addCustomizableProductToCart, data;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              state = _ref9.state, commit = _ref9.commit;
              currentTotal = state.total;
              _context6.prev = 2;

              if (!USE_MERCURE(this.getters['i18n/locale'].iso)) {
                _context6.next = 17;
                break;
              }

              if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
                logout();
              }

              if (localStorage.getItem('MDM_CART_TOKEN')) {
                _context6.next = 8;
                break;
              }

              _context6.next = 8;
              return initCart(this);

            case 8:
              _context6.next = 10;
              return _addCartCustomizable(this, localStorage.getItem('MDM_CART_TOKEN'), localStorage.getItem('MDM_ACCESS_TOKEN'), payload);

            case 10:
              _ref10 = _context6.sent;
              addCustomizableProductToCart = _ref10.addCustomizableProductToCart;
              commit(types.SET_CART_QTY, currentTotal + 1);
              commit(types.SET_CART, addCustomizableProductToCart.items);
              commit(types.SET_CART_SUCCESS, true);
              _context6.next = 21;
              break;

            case 17:
              _context6.next = 19;
              return addCustomerCartCustomizable(this, payload);

            case 19:
              data = _context6.sent;

              if (data.success) {
                commit(types.SET_CART_QTY, currentTotal + 1);
                commit(types.SET_CART_SUCCESS, true);
              } else {
                commit(types.SET_CART_SUCCESS, false);
              }

            case 21:
              _context6.next = 27;
              break;

            case 23:
              _context6.prev = 23;
              _context6.t0 = _context6["catch"](2);
              commit(types.SET_CART_SUCCESS, false);
              this.$logger.error(_context6.t0);

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[2, 23]]);
    }));

    function addCartCustomizable(_x7, _x8) {
      return _addCartCustomizable2.apply(this, arguments);
    }

    return addCartCustomizable;
  }()
};